import { checkPermission } from '@/router/guards.ts'

const ReviewModule = () => import('./FuelStationReviewModule.vue')
const FuelStationReviewIndex = () => import('./views/FuelStationReviewIndex.vue')

export const fuelStationReviewRoute = {
  path: '/fuel-station-reviews',
  name: 'fuel-station-review',
  component: ReviewModule,
  meta: {
    title: 'Fuel Station Reviews',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'fuel-station-reviews-index',
      component: FuelStationReviewIndex,
      meta: {
        permission: 'station_review.view',
      },
      beforeEnter: checkPermission('station_review.view'),
    },
  ],
}
